// extracted by mini-css-extract-plugin
export default {"card":"CardGrey_card__2Jcrq"};